import styles from './Header.module.scss';

export default function Header() {
  return <div className={styles.header}>
    <img src="https://anima-uploads.s3.amazonaws.com/projects/602e4b5bc41bd42bb40d985f/releases/603750267eb7cb25fb6a7f2a/img/logo-1@1x.png"/>
  </div>;
}
